import Nav from './components/Navbar';
import Main from './components/Main';
import './App.css';
function App() {
    
 return (
    <div className="App"> 
        <Nav />
        <Main/>
    </div>
 )
}

export default App;
